import computed from './computed'
import data from './data'
import methods from './methods'
import mounted from './mounted'

export default {
  computed,
  data,
  methods,
  mounted
}



// WEBPACK FOOTER //
// ./src/app/settings/covenants/resources/index.js